import React from 'react';
import { AzureMP } from 'react-azure-mp';

const VideoPlayer = (video) => {
  video = video.video.video;

  return  <div className="sliderVideoPlayer">
            <AzureMP
            options={{controls: false}}
            src={[{src: video.video_url, type: "application/vnd.ms-sstr+xml" }]}
            />
          </div> 
}

export default VideoPlayer;